import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { Image } from '@/atoms/Image'
import {
  CaptionSM,
  HeadingXS,
  LabelSM,
  ParagraphMD,
  ParagraphSM,
  TitleLG,
  TitleMD,
  TitleSM,
  TitleXS,
} from '@/atoms/Text'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'

interface DefaultStepProps {
  handleGiftClick: () => void
  onClose: () => void
  onCopyClick: () => void
  showtimesLink: string
  source: 'tickets' | 'landing' | 'default'
}
export const DefaultStep = ({
  handleGiftClick,
  onClose,
  onCopyClick,
  showtimesLink,
  source = 'default',
}: DefaultStepProps) => {
  const { t } = useTranslate('common')
  const router = useSafeRouter()
  return (
    <>
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-black/10 p-2" onClick={onClose}>
        <CloseIcon color="black" size={16} />
      </div>
      {source === 'tickets' ? (
        <FlexColumn className="gap-8 pb-6">
          <FlexColumn className="gap-2 text-left md:pr-5">
            <TitleMD weight={'semibold'} color={'black'} className={'hidden md:block'}>
              {t('howWouldyouliketouseyourguildtickets', `How would you like to use your 2 Guild Tickets?`)}
            </TitleMD>
            <TitleXS weight={'semibold'} color={'black'} className={'pr-8 md:hidden'}>
              {t('howWouldyouliketouseyourguildtickets', `How would you like to use your 2 Guild Tickets?`)}
            </TitleXS>
          </FlexColumn>
        </FlexColumn>
      ) : (
        <FlexColumn className="gap-8 pb-8">
          <FlexColumn className="gap-2">
            <div className="mx-auto mb-4 hidden rounded-full bg-warning-50 p-[1.125rem] md:block">
              <TicketIcon size={32} color="warm-03" />
            </div>
            <div className="mx-auto mb-4 rounded-full bg-warning-50 p-4 md:hidden">
              <TicketIcon size={24} color="warm-03" />
            </div>
            <HeadingXS weight="bold" className="text-[1.25rem] leading-[2rem] -tracking-[0.03125rem] md:text-[1.75rem]">
              {t('shareTheLightHeading', 'Share the Light')}
            </HeadingXS>
            <ParagraphMD
              weight={'medium'}
              color={'core-gray-700'}
              className="text-[0.875rem] leading-[1.625rem] md:text-base md:leading-[1.75rem]"
            >
              {t(
                'shareTheLightGuild',
                'Use your tickets to invite someone or gift them to someone who needs a little light.',
              )}
            </ParagraphMD>
          </FlexColumn>
        </FlexColumn>
      )}
      <FlexColumn className="gap-2">
        {source === 'tickets' ? (
          <>
            {showtimesLink && (
              <FlexColumn
                className="align-items-center cursor-pointer justify-center overflow-hidden rounded-xl"
                onClick={() => {
                  router.push(showtimesLink)
                }}
              >
                <div className={'relative h-[120px] w-[420px] overflow-hidden md:h-[130px]'}>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Image
                      src={'/v1747671566/66f3793a962a8c35a4e10d9c535b1836fca8f6e0_oeo88u'}
                      width={420}
                      height={130}
                      style={{ objectFit: 'cover' }}
                      alt={''}
                    />
                  </div>
                  <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                    <div className={'relative flex w-full justify-end'}>
                      <div className="relative left-0 top-0 z-10 block  h-[120px] w-[400px] bg-gradient-to-r from-[#711601] to-transparent  to-100% md:h-[130px] lg:!h-[140px] " />
                      <div className="w-[250px] lg:w-[215px]" />
                    </div>
                  </div>
                  <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                    <div className={'relative w-full flex-col justify-start gap-1 p-4 text-left text-white'}>
                      <TitleLG className={'hidden pb-1 md:block'} weight={'bold'}>
                        {t('pickYourSeats', `Pick Your Seats`)}
                      </TitleLG>
                      <TitleXS weight={'semibold'} className={'md:hidden'}>
                        {t('pickYourSeats', `Pick Your Seats`)}
                      </TitleXS>
                      <TitleXS className={'hidden md:block'} weight={'normal'}>
                        {t('ataTheaterNearYou', `at a Theater Near You`)}
                      </TitleXS>
                      <CaptionSM weight={'medium'} className={'md:hidden'}>
                        {t('ataTheaterNearYou', `at a Theater Near You`)}
                      </CaptionSM>
                    </div>
                  </div>
                </div>
              </FlexColumn>
            )}
            <FlexColumn
              className="align-items-center cursor-pointer justify-center overflow-hidden rounded-xl"
              onClick={onCopyClick}
            >
              <div className={'relative h-[120px] w-[420px] overflow-hidden md:h-[130px]'}>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Image
                    src={'/v1747671565/8eee7944fec55bc59583a345a780f9b3a20aebe6_ytlcd3'}
                    width={420}
                    height={130}
                    style={{ objectFit: 'cover' }}
                    alt={''}
                  />
                </div>
                <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                  <div className={'relative flex w-full justify-end'}>
                    <div className="relative left-0 top-0 z-10 block  h-[130px] w-[400px] bg-gradient-to-r from-[#330F4D]  to-transparent to-100% lg:!h-[140px] " />
                    <div className="w-[250px] lg:w-[215px]" />
                  </div>
                </div>
                <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                  <div className={'relative w-full flex-col justify-start gap-1 p-4 text-left text-white'}>
                    <TitleLG className={'hidden pb-1 md:block'} weight={'bold'}>
                      {t('shareYourTickets', `Share Your Tickets`)}
                    </TitleLG>
                    <TitleXS weight={'semibold'} className={'md:hidden'}>
                      {t('shareYourTickets', `Share Your Tickets`)}
                    </TitleXS>
                    <TitleXS className={'hidden md:block'} weight={'normal'}>
                      {t('toyourFriendsandFamily', `to your Friends & Family`)}
                    </TitleXS>
                    <CaptionSM weight={'medium'} className={'md:hidden'}>
                      {t('toyourFriendsandFamily', `to your Friends & Family`)}
                    </CaptionSM>
                  </div>
                </div>
              </div>
            </FlexColumn>
            <FlexColumn
              className="align-items-center cursor-pointer justify-center overflow-hidden rounded-xl"
              onClick={handleGiftClick}
            >
              <div className={'relative h-[130px] w-[420px] overflow-hidden'}>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Image
                    src={'/v1747671565/bde9faf06eb91d6a97d5dab9c6851dc0f85f3a17_r5qq4n'}
                    width={420}
                    height={130}
                    style={{ objectFit: 'cover' }}
                    alt={''}
                  />
                </div>
                <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                  <div className={'relative flex w-full justify-end'}>
                    <div className="relative left-0 top-0 z-10 block  h-[130px] w-[400px] bg-gradient-to-r from-[#0E7358]  to-transparent to-100% lg:!h-[140px] " />
                    <div className="w-[250px] lg:w-[215px]" />
                  </div>
                </div>
                <div className={'absolute left-0 top-0 z-10   h-[160px] w-full min-w-[200px] lg:!h-[140px]'}>
                  <div className={'relative w-full flex-col justify-start gap-1 p-4 text-left text-white'}>
                    <TitleLG className={'hidden pb-1 md:block'} weight={'bold'}>
                      {t('letAngelGiftThem', 'Let Angel Gift Them')}
                    </TitleLG>
                    <TitleXS weight={'semibold'} className={'md:hidden'}>
                      {t('letAngelGiftThem', 'Let Angel Gift Them')}
                    </TitleXS>
                    <TitleXS className={'hidden md:block'} weight={'normal'}>
                      {t('andWellGiftThemtoSomeoneDeserving', `and We’ll Gift Them to Someone Deserving`)}
                    </TitleXS>
                    <CaptionSM weight={'medium'} className={'md:hidden'}>
                      {t('andWellGiftThemtoSomeoneDeserving', `and We’ll Gift Them to Someone Deserving`)}
                    </CaptionSM>
                  </div>
                </div>
              </div>
            </FlexColumn>
          </>
        ) : (
          <>
            <FlexColumn className="gap-2">
              <FlexColumn className="gap-3 rounded-xl border border-core-gray-200 bg-core-gray-100 md:gap-8">
                <div className={'flex flex-col gap-3 p-3 md:flex-row md:gap-6 md:p-4'}>
                  <FlexColumn className="items-start gap-1.5 md:gap-2">
                    <TitleSM className={'hidden md:block'} weight={'semibold'}>
                      {t('shareYourTickets', 'Share Your Tickets')}
                    </TitleSM>
                    <TitleXS className={'md:hidden'} weight={'semibold'}>
                      {t('shareYourTickets', 'Share Your Tickets')}
                    </TitleXS>
                    <ParagraphSM
                      weight={'medium'}
                      className="hidden text-left text-[0.8125rem] leading-[1rem] md:block md:text-sm md:leading-[1.625rem]"
                      color={'core-gray-700'}
                    >
                      {t('ShareYourGuildTicketsDescription', 'Send your tickets to a friend or family member.')}
                    </ParagraphSM>
                    <CaptionSM color={'core-gray-700'} weight={'medium'} className={'md:hidden'}>
                      {t('ShareYourGuildTicketsDescription', 'Send your tickets to a friend or family member.')}
                    </CaptionSM>
                  </FlexColumn>
                  <FlexColumn className={'md:justify-center'}>
                    <Button
                      onClick={onCopyClick}
                      className="min-w-[9.375rem] items-center gap-1.5 rounded-[0.875rem] px-5 py-3 text-sm font-normal md:!py-3"
                      variant="black"
                    >
                      <LabelSM className={'md:hidden'} weight={'semibold'}>
                        {t('shareMyTickets', 'Share My Tickets')}
                      </LabelSM>
                      <span className={'hidden md:block'}>{t('copyInviteLink', 'Copy Invite Link')}</span>
                    </Button>
                  </FlexColumn>
                </div>
              </FlexColumn>

              <FlexColumn className="gap-3 rounded-xl border border-core-gray-200 bg-core-gray-100 md:gap-8">
                <div className={'flex flex-col gap-4 p-3 md:flex-row md:gap-6 md:p-4'}>
                  <FlexColumn className="items-start gap-1.5 text-left md:gap-2">
                    <TitleSM className={'hidden md:block'} weight={'semibold'}>
                      {t('letAngelGiftThem', 'Let Angel Gift Them')}
                    </TitleSM>
                    <TitleXS className={'md:hidden'} weight={'semibold'}>
                      {t('letAngelGiftThem', 'Let Angel Gift Them')}
                    </TitleXS>
                    <ParagraphSM
                      weight={'medium'}
                      className="hidden text-left text-[0.8125rem] leading-[1rem] md:block md:text-sm md:leading-[1.625rem]"
                      color={'core-gray-700'}
                    >
                      {t('giftYourGuildTicketsDescription', "Can't use your tickets? We'll gift your tickets for you.")}
                    </ParagraphSM>
                    <CaptionSM color={'core-gray-700'} weight={'medium'} className={'md:hidden'}>
                      {t('giftYourGuildTicketsDescription', "Can't use your tickets? We'll gift your tickets for you.")}
                    </CaptionSM>
                  </FlexColumn>
                  <FlexColumn className={'md:justify-center'}>
                    <Button
                      onClick={handleGiftClick}
                      className="min-w-[9.375rem] items-center gap-1.5 rounded-[0.875rem] px-5 py-3 text-sm font-normal"
                      variant="oxide"
                    >
                      {t('giftMyTickets', 'Gift My Tickets')}
                    </Button>
                  </FlexColumn>
                </div>
              </FlexColumn>
            </FlexColumn>
          </>
        )}
      </FlexColumn>
    </>
  )
}
